import { ChannelTypeEnum } from '../models/enum/channel.type';

/**
 * Frontend mirror of `buildAgentSignature` in `@app/trendmulti-core`. The two must stay in
 * step: the panel writes the signature onto the message, the backend writes it onto the
 * scheduled send, and both reach the same customer.
 *
 * WhatsApp renders `_*Name*_` as bold italic. RCS has no rich text — its text content is a
 * plain string — so the markers travel to the customer verbatim and the handset shows
 * `_*Vinicius Nascimento*_`. The name is sent unadorned there instead.
 *
 * Written as a POSITIVE check on RCS so a channel whose type cannot be resolved keeps the
 * formatting it has today.
 *
 * Returns the signature TOKEN only — each call site keeps the separator it already uses.
 */
export function buildAgentSignature(channelType: ChannelTypeEnum | string | undefined | null, name: string | undefined | null): string {
  const agentName = String(name ?? '').trim();
  if (!agentName) return '';
  return channelType === ChannelTypeEnum.RCS_API ? agentName : `_*${agentName}*_`;
}

/**
 * Splits the author's signature off the head of a stored message, so an edit changes the
 * text and keeps the signature the message went out with. Both separators written so far
 * are recognised: the send's `\n` and the ` \n\n ` earlier edits wrote.
 */
export function splitAgentSignature(content: string | undefined | null, channelType: ChannelTypeEnum | string | undefined | null, authorName: string | undefined | null): { signature: string; text: string } {
  const value = String(content ?? '');
  const signature = buildAgentSignature(channelType, authorName);
  const separator = signature && value.startsWith(signature) ? /^[ \t]*\n\s*/.exec(value.slice(signature.length)) : null;
  return separator
    ? { signature, text: value.slice(signature.length + separator[0].length) }
    : { signature: '', text: value };
}
